import { AgentTool, AgentToolResult } from './agent-tool.types';
import { WsToolDeclaration } from '../ws/agent-ws.types';
import { getRegistry, listRegistryLabels } from '../registries/registry-catalog';

/**
 * Возвращает схему фильтров выбранного реестра для сборки блока `registry_link`.
 */
export class AgentRegistryFiltersTool implements AgentTool {
    /** @inheritdoc */
    public readonly declaration: WsToolDeclaration = {
        toolName: 'get_registry_filters',
        description:
            'Возвращает описание поддерживаемых URL-фильтров для реестра приложения. '
            + `Поддерживаемые реестры: ${listRegistryLabels().join(', ')}. `
            + 'В аргументе registry передавай только id (часть до скобок). '
            + 'Обязательно вызови эту тулзу с нужным registry ПЕРЕД тем, как собирать блок registry_link. '
            + 'Не угадывай имена параметров - используй только ключи и типы из ответа инструмента. '
            + 'Используй фильтр, когда пользователь просит показать или открыть список документов. '
            + 'Фильтр не возвращает сами записи, количество, суммы или текущую очередь согласования сотрудника. '
            + 'Для фактического ответа получи данные документов через API; не выдавай ссылку на выборку вместо запрошенного числа или статуса.',
        requestFormat: {
            registry: 'string - id реестра (например orders)',
        },
        responseFormat: {
            registry: 'string',
            title: 'string',
            path: 'string',
            filters: 'array of { key, label, description, valueType, enumValues? }',
        },
    };

    /** @inheritdoc */
    public async execute(args: Record<string, unknown>): Promise<AgentToolResult> {
        const registryId = typeof args['registry'] === 'string' ? args['registry'].trim() : '';

        if (!registryId) {
            return {
                ok: false,
                error: {
                    code: 'invalid_args',
                    message: `Параметр registry обязателен. Доступные реестры: ${listRegistryLabels().join(', ')}`,
                },
            };
        }

        const registry = getRegistry(registryId);

        if (!registry) {
            return {
                ok: false,
                error: {
                    code: 'unknown_registry',
                    message: `Неизвестный реестр "${registryId}". Доступные: ${listRegistryLabels().join(', ')}`,
                },
            };
        }

        return {
            ok: true,
            payload: {
                registry: registry.id,
                title: registry.title,
                path: registry.path,
                filters: registry.filters.map((field) => ({
                    key: field.key,
                    label: field.label,
                    description: field.description,
                    valueType: field.valueType,
                    ...(field.enumValues ? { enumValues: [...field.enumValues] } : {}),
                })),
            },
        };
    }
}
